import {PageInfoType} from "../../definitions/types";

export class PageInfoModel {
    private readonly _startCursor?: string;
    private readonly _endCursor?: string;
    private readonly _hasNextPage: boolean;
    private readonly _hasPreviousPage: boolean;

    constructor(pageInfoType?: PageInfoType) {
        this._startCursor = pageInfoType?.startCursor;
        this._endCursor = pageInfoType?.endCursor;
        this._hasNextPage = pageInfoType?.hasNextPage ?? false;
        this._hasPreviousPage = pageInfoType?.hasPreviousPage ?? false;
    }

    /**
     * @method startCursor
     * @description Returns the start cursor of the page info. This is the cursor of the first item in the page.
     * @returns {string | undefined}
     */
    public get startCursor(): string | undefined {
        return this._startCursor;
    }

    /**
     * @method endCursor
     * @description Returns the end cursor of the page info. This is the cursor of the last item in the page.
     * @returns {string | undefined}
     */
    public get endCursor(): string | undefined {
        return this._endCursor;
    }

    /**
     * @method hasNextPage
     * @description Returns whether there is a next page of items.
     * @returns {boolean}
     */
    public get hasNextPage(): boolean {
        return this._hasNextPage;
    }

    /**
     * @method hasPreviousPage
     * @description Returns whether there is a previous page of items.
     * @returns {boolean}
     */
    public get hasPreviousPage(): boolean {
        return this._hasPreviousPage;
    }
}